export default __webpack_public_path__ + "static/media/about-kahsh.62992ea1.png";